import * as React from 'react';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Breadcrumbs, { breadcrumbsClasses } from '@mui/material/Breadcrumbs';
import NavigateNextRoundedIcon from '@mui/icons-material/NavigateNextRounded';
// --- MODIFIED: Import matchPath to handle dynamic routes ---
import { useLocation, matchPath } from 'react-router-dom';

const StyledBreadcrumbs = styled(Breadcrumbs)(({ theme }) => ({
  margin: theme.spacing(1, 0),
  [`& .${breadcrumbsClasses.separator}`]: {
    color: (theme.vars || theme).palette.action.disabled,
    margin: 1,
  },
  [`& .${breadcrumbsClasses.ol}`]: {
    alignItems: 'center',
  },
}));

// --- NEW: A mapping for URL paths to their friendly names ---
const pathMap = {
  '/': 'Overview',
  '/hazards': 'Hazards',
  '/scenarios': 'Scenarios',
  '/networks': 'Networks',
  '/settings': 'Settings',
  '/about': 'About',
  '/feedback': 'Feedback',
  '/report': 'Report',
  // Add the new dynamic route pattern for scenario reports
  '/report/scenarios/:scenarioId': 'Scenario Report',
};

export default function NavbarBreadcrumbs() {
  const location = useLocation();
  
  // --- MODIFIED: The getPageTitle function is now smarter ---
  const getPageTitle = () => {
    const path = location.pathname;
    
    // Check for a dynamic route match first
    for (const routePath in pathMap) {
        // The `matchPath` function checks if the current URL matches a defined pattern
        if (matchPath(routePath, path)) {
            return pathMap[routePath];
        }
    }
    
    // Fallback to the original logic if no specific match is found
    const page = path.split('/').pop();
    return page ? page.charAt(0).toUpperCase() + page.slice(1) : 'Overview';
  };

  return (
    <StyledBreadcrumbs
      aria-label="breadcrumb"
      separator={<NavigateNextRoundedIcon fontSize="small" />}
    >
      <Typography variant="body1">Infrastructure Dashboard</Typography>
      <Typography variant="body1" sx={{ color: 'text.primary', fontWeight: 600 }}>
        {getPageTitle()}
      </Typography>
    </StyledBreadcrumbs>
  );
}